
export default {
  layout: 'technos',
  mounted() {
    new RDStationForms(
      'aula-experimental-technos-e432f6694cc7fec35dc1',
      'UA-228576147-2'
    ).createForm()
  },
}
